<template>
  <div class="empty_list">
    <div class="empty_img"></div>
    <div class="empty_text">게시물이 없습니다.</div>
  </div>
</template>

<script>
export default {
  name: "BoardEmptyDefaultLayout",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>